var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ShopAfterSalesService from "../../api/ShopAfterSalesService";
import CommonService from '../../api/CommonService';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import { Loading } from 'element-ui';
import viewImgList from './components/viewImgList';
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.formData = {
            refund_order_id: '',
            images: [],
            refund_order_detail: []
        };
        _this.rowId = '';
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    Detail.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 340;
        }, 300);
    };
    Detail.prototype.created = function () {
        this.service = ShopAfterSalesService.getInstance();
        this.commonService = CommonService.getInstance();
        if (this.rowId) {
            this.getDetail();
        }
        this.getGoodsTypeList();
    };
    Detail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Detail.prototype.search = function () {
        this.getDetail();
    };
    Detail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            refund_order_id: this.rowId,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        console.log(1111, params);
        this.service.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            data.refund_order_detail = data.refund_order_detail || [];
            data.refund_order_detail.forEach(function (item, index) {
                if (item.order_goods_replace && item.order_goods_replace.length !== 0) {
                    item.order_goods_replace.goods_format_name = item.order_goods_replace.supplier_goods_format;
                    item.order_goods_replace.remark = item.order_goods_replace.order_detail_icomment;
                    item.children = [item.order_goods_replace];
                }
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
            _this.formData = data;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
                viewImgList: viewImgList
            },
            methods: {}
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
